import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useState } from "react";
import styled from "styled-components";

const NavContainer = styled(motion.nav)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  padding: 1rem 5%;
  background: linear-gradient(120deg, #dcaa14, #dcaa14);
  backdrop-filter: blur(10px);
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Logo = styled.a`
  font-size: 1.5rem;
  font-weight: 700;
  background: #ffffff;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  display: flex;
  align-items: center;
  gap: 1rem;
  font-family: "Noto Serif", serif;
  letter-spacing: 0.1rem;
`;

const NavLinks = styled.div`
  display: flex;
  gap: 2rem;
  align-items: center;

  @media (max-width: 768px) {
    display: none;
  }
`;

const NavLink = styled(motion.a)`
  color: #ffffff;
  text-decoration: none;
  font-weight: 500;
  position: relative;
  cursor: pointer;

  &::after {
    content: "";
    position: absolute;
    bottom: -4px;
    left: 0;
    width: 0;
    height: 2px;
    background: linear-gradient(120deg, #dcaa14, #dcaa14);
    transition: width 0.3s ease;
  }

  &:hover::after {
    width: 100%;
  }
`;

const CTAButton = styled(motion.button)`
  padding: 0.75rem 1.5rem;
  background: #ffffff;
  border: none;
  border-radius: 25px;
  color: #000000;
  font-weight: 600;
  cursor: pointer;
`;

const MobileMenuButton = styled(motion.button)`
  display: none;
  background: none;
  border: none;
  color: white;
  font-size: 1.5rem;
  cursor: pointer;

  @media (max-width: 768px) {
    display: block;
  }
`;

const MobileMenu = styled(motion.div)`
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.95);
  padding: 2rem;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 2rem;
  }
`;

const Navbar = ({ isHome = false }: { isHome?: boolean }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 600);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <NavContainer
        initial={{ y: -100 }}
        animate={{ y: 0 }}
        transition={{ duration: 0.5 }}
        style={{
          background: isScrolled
            ? "linear-gradient(120deg, #dcaa14, #dcaa14)"
            : "transparent",
        }}
      >
        <Logo href="/#">
          <img
            src="https://wfkq0nguanh0273r.public.blob.vercel-storage.com/logo-alone.png"
            alt="Logo"
            className="me-2"
            style={{ width: "40px", height: "50px" }}
          />
          STUPRO
        </Logo>
        <NavLinks>
          {isHome ? (
            <NavLink href="/">Home</NavLink>
          ) : (
            <>
              {/* <NavLink href="#about">About</NavLink> */}
              <NavLink href="#contact">Contact</NavLink>
            </>
          )}
          <CTAButton whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }} onClick={() => {window.location.href = "https://play.google.com/store/apps/details?id=com.stupro";}}>
            Download Now
          </CTAButton>
        </NavLinks>
        <MobileMenuButton
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          {isMobileMenuOpen ? "✕" : "☰"}
        </MobileMenuButton>
      </NavContainer>

      <AnimatePresence>
        {isMobileMenuOpen && (
          <MobileMenu
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.3 }}
          >
            {isHome ? (
              <NavLink href="/">Home</NavLink>
            ) : (
              <>
                {/* <NavLink href="/#about">About</NavLink> */}
                <NavLink href="/#contact">Contact</NavLink>
              </>
            )}
            <CTAButton whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
              Download Now
            </CTAButton>
          </MobileMenu>
        )}
      </AnimatePresence>
    </>
  );
};

export default Navbar;
